module.exports = __webpack_public_path__ + "./video/minecraftparkour.93f555449b4fa271631b8c4c1ed47c10.mp4";